module.exports = __webpack_public_path__ + "img/icon.24ed6c07.svg";